export default __webpack_public_path__ + "static/media/D1948_04_04_Rosano.7c190273.jpg";